module.exports = __webpack_public_path__ + "static/hero-preview-962b83d89e268c5172a11116aa23c170.png";